/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum SchemaFieldType {
    TEXT = 'Text',
    NUMBER = 'Number',
    BOOLEAN = 'Boolean',
    SELECT = 'Select',
    IMAGE = 'Image',
    JSON = 'JSON',
    LOKALISE_KEY = 'LokaliseKey',
    LONG_TEXT = 'LongText'
}



